module.exports = __webpack_public_path__ + "img/partners_cont03.f68c2f6b.jpg";